// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"5cee97f4","182":"fcce23a5","254":"5fa46759","431":"e4bd6f2f","488":"34d73016","688":"6629e938","784":"ddd23e88","830":"0461d7b9","910":"cb0f75a8","930":"043a0e77","964":"bddeebcb"}[chunkId] + ".chunk.js";
};